import { HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ContentHubListResponse } from '../model/content-hub/content-hub-response.model';
import { ContentHubMedifitMedicalResponse } from '../model/content-hub/dto/medifit-medical.dto';
import { MedifitMedicalMapper } from '../model/content-hub/mapper/medifit-medical.mapper';
import { ContentHubMedifitMedical } from '../model/content-hub/model/medifit-medical.model';
import { HelperService } from './helper.service';
import { HttpClientService } from './http-client.service';

@Injectable({
    providedIn: 'root',
})
export class ContentHubService {
    private httpClient = inject(HttpClientService);
    private helper = inject(HelperService);

    private readonly LOCALE = 'sl';

    public getContentHub<T>(url: string, params: HttpParams = new HttpParams()): Observable<T> {
        const httpOptions = {
            headers: new HttpHeaders({ authorization: 'Bearer ' + environment.contentHub?.token }),
            params: params,
        };

        return this.httpClient.get(`${this.helper.getContentHubUrl(url)}`, httpOptions);
    }

    public getMedifitMedical(hdApp?: string, bsId?: number): Observable<ContentHubMedifitMedical> {
        let params = new HttpParams();
        if (hdApp) {
            params = params.set('filters[hdApp]]$eq]', hdApp);
        }
        if (bsId) {
            params = params.set('filters[bsId][$eq]', bsId);
        }
        params = params.set('locale', this.LOCALE);
        return this.getContentHub<ContentHubListResponse<ContentHubMedifitMedicalResponse>>(`medifit-medicals`, params).pipe(
            map(results => {
                return results?.data?.[0]?.attributes ? new MedifitMedicalMapper().mapDtoToModel(results?.data?.[0]?.attributes) : null;
            }),
        );
    }
}
